import { stringToEnum } from '@snap-types/models/common';

export enum VisualWorkOrderType {
  MASTER = 'M',
  WORK_ORDER = 'W',
  QUOTE = 'Q',
}

export enum VisualWorkOrderStatus {
  CLOSED = 'C',
  CANCELLED = 'X',
  RELEASED = 'R',
  FIRMED = 'F',
  UNRELEASED = 'U',
}
export const visualWorkOrderTypeSchema = stringToEnum(VisualWorkOrderType);
export const visualWorkOrderStatusSchema = stringToEnum(VisualWorkOrderStatus);
